export default "__VITE_ASSET__CmY9SXlh__"